import React, { useEffect } from 'react';
import { MenuItem, Paper, Select, InputLabel} from '@mui/material';
import { SelectChangeEvent } from '@mui/material/Select';
import { CompletedRounds } from '../../globals/BBLData';
export interface Props {
    selectedRound: number;
    onChange: Function;
    availableRounds: number[];
}

const RoundSelector = ({selectedRound, onChange, availableRounds}:Props) => {
    useEffect(() => {},[selectedRound]);
    return <div>
        <div style={{display: "flex", flexDirection: "column", justifyContent: 'flex-start', alignItems: "flex-start", marginLeft: "auto",marginBottom: '1rem',paddingTop: "1rem"}}>
            <InputLabel id={`playerownershipselect`}>Round</InputLabel>
            <Select
                value={selectedRound}
                label={"Round"}
                onChange={e => onChange(e)}
                labelId={"playerownershipselect"}
                style={{width: 250, textAlign: "left",textTransform: 'capitalize'}}
            >
                {availableRounds.map(function(po) {
                    return <MenuItem
                        value={po}>
                            {po}
                        </MenuItem>
                })}
            </Select>
        </div>
    </div>
}

export default RoundSelector;